export const FeatureFlagsEnum = {
  autoSave: 'autosave'
}
